import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    appointments: {},
    selectedAppointmentsId:"",
    selectedSuperAdminServiceIdForPackage:""
};


const appointments = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_APPOINTMENTS_LIST: {
      draft.appointments = payload?.appointments;
      break;
    }
    case Actions.SELECTED_APPOINTMENTS_ID: {
      draft.selectedAppointmentsId = payload?.selectedAppointmentsId;
      break;
    }
    case Actions.SELECTED_SUPER_ADMIN_SERVICE_ID_FOR_PACKAGE: {
      draft.selectedSuperAdminServiceIdForPackage = payload?.selectedSuperAdminServiceIdForPackage;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default appointments;
